import { NextRequest, NextResponse } from "next/server";

export default function middleware(request: NextRequest) {
  if (!request.nextUrl.pathname.includes("_next")) {
    const searchParams = request.nextUrl.searchParams;

    const queryRootUrl = searchParams.get("rootUrl");

    const response = NextResponse.next();

    const rootUrlCookie = request.cookies.get("rootUrl")?.value;

    if (queryRootUrl) {
      response.cookies.set("rootUrl", String(queryRootUrl));
    } else if (rootUrlCookie) {
      response.cookies.set("rootUrl", String(rootUrlCookie));
    }

    return response;
  }
  return NextResponse.next();
}
